import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-hardware',
  templateUrl: './icon-hardware.component.html',
  styleUrls: ['./icon-hardware.component.scss']
})
export class IconHardwareComponent implements OnInit {

  @Input() cssClass = 'icon--18';

  constructor() { }

  ngOnInit() {
  }

}
